import http from '@/utils/http'

/**
 * 获取图形验证码 + RSA 公钥
*/
export function getCaptcha() {
    return http({
        method: 'get',
        url: '/common/captcha/get'
    })
}

/**
 * 用户登录
*/
export function login(data) {
    return http({
        method: 'post',
        url: '/sysAdmin/login',
        data
    })
}

/**
 * 用户登出
*/
export function logout() {
    return http({
        method: 'post',
        url: '/sysAdmin/logout'
    })
}

/**
 * 修改密码
*/
export function modifyPwd(data) {
    return http({
        method: 'post',
        url: '/sysAdmin/password/update',
        data
    })
}
